<div class="input-container" [ngClass]="{'label-on-top': labelPosition == 'top', 'preview': preview}">
    <div class="field-label"
         kendoTooltip
         [ngStyle]="{'flex-basis': labelWidth}"
         [ngClass]="{'invalid': valid === false, 'disabled': disabled}">
        {{labelText}}

        <span *ngIf="!!tooltip" class="tooltip-icon" [title]="tooltip">?</span>
    </div>
    <div class="field-input">
        <ng-content></ng-content>
    </div>
</div>

